export const isEmpty = (str: string) => {
  return (
    !str ||
    0 === str.length ||
    (str.constructor === Object && Object.keys(str).length === 0) ||
    (str.constructor === String && str.trim().length === 0)
  );
};
